import React, { useEffect, useState } from 'react';

interface Props {
  packageTypeData: any;
  packagesForm: any;
  setPackagesForm: any;
}
function PackageTypeSelect({
  packageTypeData,
  packagesForm,
  setPackagesForm,
}: Props) {
  return (
    <div className='row '>
      <div className='col-sm-12'>
        <label className='globalInputLabel' htmlFor='main_type'>
          Package Type
          <span className='text-danger fw-bold ms-1'>*</span>
        </label>
        <select
          className={`form-select form-control ubbe-input ${
            packagesForm?.package_id ? 'highlighted-border' : ''
          }`}
          name=''
          id='main_type'
          data-width='100%'
          data-size='8'
          value={packagesForm?.package_id}
          defaultValue={packagesForm?.package_id}
          onChange={(e) => {
            let selectedId = Number(e.target.value);
            packageTypeData &&
              packageTypeData.length > 0 &&
              packageTypeData.filter((pkg: any) => {
                if (pkg.id === selectedId) {
                  setPackagesForm({
                    ...packagesForm,
                    package_type: pkg.code?.toUpperCase(),
                    package_id: pkg.id,
                    package_description: pkg.name,
                  });
                }
              });
          }}
        >
          <optgroup label='Common'>
            {packageTypeData &&
              packageTypeData.length > 0 &&
              packageTypeData
                .filter((pkg: any) => pkg.is_common)
                .map((pkg: any) => (
                  <option key={pkg.id} value={pkg.id}>
                    {pkg.name}
                  </option>
                ))}
          </optgroup>
          <optgroup label='Other'>
            {packageTypeData &&
              packageTypeData.length > 0 &&
              packageTypeData
                .filter((pkg: any) => !pkg.is_common)
                .map((pkg: any) => (
                  <option key={pkg.id} value={pkg.id}>
                    {pkg.name}
                  </option>
                ))}
          </optgroup>
        </select>
      </div>
    </div>
  );
}

export default PackageTypeSelect;
